import { render } from "./snackbar_message.html?vue&type=template&id=63e54195&external"
import script from "./snackbar_message.js?vue&type=script&lang=js&external"
export * from "./snackbar_message.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__